import React, {useState} from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "./WhatInvetors.css";
import right from "./assets/right.png";
import left from "./assets/left.png";
import { FreeMode, Navigation } from "swiper";
import TweetFeed from "../TweetFeed/TweetFeed";
const WhatInvetors = () => {
  const Card = () => (
    <div className="pt-[24px]  w-full  testimonials-card-wrap   pl-[33px] pr-[30px] pb-[28px] bg-main-green text-main-black rounded-[10px]">
      <p className="text-res-xs w-full tracking-[0.06em] font-semibold italic leading-[28px]">
        "I've been a part of the R34P DAO community for months now, and it has
        been an incredible experience. The NFTs I've acquired have not only
        appreciated in value, but they have also given me a voice in the
        governance decisions of the DAO. It's empowering to be a part of a
        community that is shaping the future of DeFi."
      </p>
      <span className="font-black text-res-xs block pt-[9px]">-Emily W</span>
    </div>
  );
  const responive = {
    // when window width is >= 320px
    300: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1020: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1330: {
      slidesPerView: 3,
      spaceBetween: 41,
    },
  };
  return (
    <div>
      <h2
        className="text-res-lg font-black mt-[200px] mb-[69px]
             text-center"
      >
        What Our Investors Say
      </h2>
      <div className="mb-[169px] mx-auto max-w-[1244px] px-3 md:px-0 relative">
          <Swiper
            slidesPerView={3}
            spaceBetween={41}
            effect="coverflow"
            centeredSlides={true}
            breakpoints={responive}
            modules={[FreeMode, Navigation]}
            navigation={{
              nextEl: ".image-swiper-button-next1",
              prevEl: ".image-swiper-button-prev1",
              disabledClass: "swiper-button-disabled",
            }}
            direction="horizontal"
            className="investor"
            initialSlide={1}
          >
            <SwiperSlide>
              <Card></Card>
            </SwiperSlide>
            <SwiperSlide>
              <Card></Card>
            </SwiperSlide>
            <SwiperSlide>
              <Card></Card>
            </SwiperSlide>
          </Swiper>
        <div className="absolute flex gap-[22px] left-1/2 bottom-[-54px] -translate-x-1/2 translate-y-1/2">
          <div className="image-swiper-button-prev1   flex justify-center items-center bg-main-black w-[50px] h-[50px] rounded-[6px] z-10 cursor-pointer select-none">
            <img src={left} alt="" />
          </div>
          <div className="image-swiper-button-next1   flex justify-center items-center bg-main-black w-[50px] h-[50px] rounded-[6px] z-10 cursor-pointer select-none">
            <img src={right} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatInvetors;
